import React, { useEffect, useState } from "react";

const EditableSection = ({
    uniqueId,
    title,
    data,
    Display,
    Editor,
    editable = false,
    onSaved
}) => {
    const [editing, setEditing] = useState(false);
    const [form, setForm] = useState(data || {});
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!editing) {
            setForm(data || {});
        }
    }, [data, editing]);

    const update = (key, value) => {
        setForm(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const updateItem = (index, key, value) => {
        setForm(prev => ({
            ...prev,
            items: (prev.items || []).map((item, i) =>
                i === index
                    ? { ...item, [key]: value }
                    : item
            )
        }));
    };

    const addItem = (item = {}) => {
        setForm(prev => ({
            ...prev,
            items: [...(prev.items || []), item]
        }));
    };

    const removeItem = index => {
        setForm(prev => ({
            ...prev,
            items: (prev.items || []).filter(
                (_, i) => i !== index
            )
        }));
    };

    const save = async () => {
        try {
            setSaving(true);

            const response = await fetch(
                `/api/content/${encodeURIComponent(uniqueId)}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        data: form
                    })
                }
            );

            if (!response.ok) {
                throw new Error("Failed to save section");
            }

            const result = await response.json();

            setEditing(false);

            if (onSaved) {
                await onSaved(result.data);
            }

        } catch (error) {
            console.error(error);
            alert(error.message || "Failed to save");
        } finally {
            setSaving(false);
        }
    };

    const cancel = () => {
        setForm(data || {});
        setEditing(false);
    };

    return (
        <div className="editable-section">

            {editable && (
                <div className="edit-toolbar">

                    <strong>{title}</strong>

                    {!editing ? (
                        <button
                            type="button"
                            onClick={() => {
                                setForm(data || {});
                                setEditing(true);
                            }}
                        >
                            Edit
                        </button>
                    ) : (
                        <div className="edit-actions">

                            <button
                                type="button"
                                onClick={save}
                                disabled={saving}
                            >
                                {saving ? "Saving..." : "Save"}
                            </button>

                            <button
                                type="button"
                                onClick={cancel}
                                disabled={saving}
                            >
                                Cancel
                            </button>

                        </div>
                    )}

                </div>
            )}

            {editing ? (
                <Editor
                    data={form}
                    update={update}
                    updateItem={updateItem}
                    addItem={addItem}
                    removeItem={removeItem}
                />
            ) : (
                <Display data={data || {}} />
            )}

        </div>
    );
};

export default EditableSection;